import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the AchievementItem component.
 */
const useAchievementItemStyles = makeStyles()(() => ({
  icon: {
    height: theme.iconSize,
    width: 'auto',
    marginBottom: theme.margin.m,
  },
  achievementItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0,
    padding: theme.padding.m,
    width: '160px',
  },
  description: {
    textAlign: 'center',
    color: colors.gray['400'],
    marginBottom: theme.margin.xs,
  },
  name: {
    textAlign: 'center',
    marginBottom: theme.margin.xs,
  },
  progress: {
    textAlign: 'center',
    color: colors.red['500'],
    fontWeight: theme.fontWeight.medium,
  },
}));

export default useAchievementItemStyles;
